<template>
  <div class="remote-warning-page">
    <!-- 左侧机构栏 -->
    <div class="sidebar">
      <el-input
        v-model="searchText"
        placeholder="搜索机构"
        class="sidebar-search"
        clearable
      >
        <i slot="prefix" class="el-icon-search search-icon"></i>
      </el-input>
      <div class="org-list">
        <div
          v-for="(org, idx) in filteredOrgs"
          :key="org.institutionName"
          :class="['org-item', { active: idx === selectedOrgIndex }]"
          @click="selectOrg(idx)"
        >
          <span class="org-name">{{ org.institutionName }}</span>
          <span class="org-count">设备数：{{ org.deviceCount }}</span>
        </div>
      </div>
    </div>
    <!-- 右侧动态加载 EquipmentWarning 组件 -->
    <div class="main-content">
      <EquipmentWarning :institution-name="currentInstitutionName" />
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import EquipmentWarning from './EquipmentWarning.vue';
import { EventBus } from '@/utils/eventBus';

export default {
  name: 'DevicePage',
  components: {
    EquipmentWarning
  },
  data() {
    return {
      orgList: [], // 机构列表
      selectedOrgIndex: 0, // 当前选中机构下标
      searchText: '',
      refreshTimer: null, // 定时器句柄
    };
  },
  computed: {
    filteredOrgs() {
      if (!this.searchText) return this.orgList;
      return this.orgList.filter(org => org.institutionName.toLowerCase().includes(this.searchText.toLowerCase()));
    },
    currentInstitutionName() {
      if (this.filteredOrgs.length === 0) return '';
      return this.filteredOrgs[this.selectedOrgIndex]?.institutionName || '';
    },
  },
  mounted() {
    this.fetchOrgList();
    // 定时器：每10秒刷新一次数据
    this.refreshTimer = setInterval(() => {
      this.fetchOrgList();
    }, 1000);
  },
  beforeDestroy() {
    // 清理定时器，防止内存泄漏
    if (this.refreshTimer) {
      clearInterval(this.refreshTimer);
      this.refreshTimer = null;
    }
  },
  methods: {
    fetchOrgList() {
      const accountNum = localStorage.getItem('agentUserInfo')?.replace(/^"|"$/g, '') ;
      axios.get(`/api/devidRealTime/selectError?accountNum=${accountNum}`)
        .then(res => {
          if (res.data && res.data.code === 0) {
            this.orgList = res.data.data || [];
            // 首次加载后广播第一个机构的设备数据
            if (this.orgList.length > 0) {
              const firstDevices = this.orgList[0].devidRealTimes || [];
              EventBus.$emit('deviceDataUpdated', firstDevices);
              // 判断是否有异常并广播状态
              const hasWarning = firstDevices.some(device =>
                device.fire === 0 ||
                device.cap === 0 ||
                device.waterLevel === 0 ||
                device.waterTemperatureAlarm === 0
              );
              EventBus.$emit('equipmentWarningStatus', hasWarning);
            } else {
              EventBus.$emit('equipmentWarningStatus', false);
            }
          } else {
            this.$message.error(res.data.msg || '获取机构数据失败');
            EventBus.$emit('equipmentWarningStatus', false);
          }
        })
        .catch(() => {
          this.$message.error('请求失败');
          EventBus.$emit('equipmentWarningStatus', false);
        });
    },
    selectOrg(idx) {
      this.selectedOrgIndex = idx;
      // 选中机构后广播该机构的设备数据
      const org = this.filteredOrgs[idx];
      if (org && org.devidRealTimes) {
        EventBus.$emit('deviceDataUpdated', org.devidRealTimes);
        // 判断是否有异常并广播状态
        const hasWarning = org.devidRealTimes.some(device =>
          device.fire === 0 ||
          device.cap === 0 ||
          device.waterLevel === 0 ||
          device.waterTemperatureAlarm === 0
        );
        EventBus.$emit('equipmentWarningStatus', hasWarning);
      } else {
        EventBus.$emit('equipmentWarningStatus', false);
      }
    },
  },
};
</script>

<style scoped>
.remote-warning-page {
  display: flex;
  height: 100%;
  background: #f5f6fa;
  padding: 20px;
}
.sidebar {
  width: 260px;
  background: #E2F3FF;
  border-radius: 10px;
  padding: 18px 0 18px 0;
  display: flex;
  flex-direction: column;
  margin-right: 20px;
}
.sidebar-search {
  margin: 0 auto 16px auto;
  width: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.el-input {
  width: 80%;
  border: transparent!important;
}
.el-input .el-input__inner {
  border-radius: 20px;
  background: #fff;
  padding-left: 36px !important;
}
.el-input .el-input__prefix {
  left: 10px;
  top: 50%;
  transform: translateY(-50%);
  height: 100%;
  display: flex;
  align-items: center;
}
.search-icon {
  font-size: 18px;
  color: #409EFF;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}
.org-list {
  flex: 1;
  overflow-y: auto;
}
.org-item {
  padding: 12px 18px;
  font-size: 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  border-left: 4px solid transparent;
  margin-bottom: 2px;
  transition: background 0.2s, border-color 0.2s;
}
.org-item.active {
  background: #e8f4ff;
  border-left: 4px solid #409EFF;
}
.org-name {
  font-weight: 500;
}
.org-count {
  color: #888;
  font-size: 13px;
}
.main-content {
  flex: 1;
  background: #fff;
  border-radius: 10px;
  padding: 18px;
  overflow-y:auto ;
}
</style>
